import { Button } from '../../Utility/Button';
import Input from '../../Utility/FormElements/Input';
import AdminContainer from '../../Utility/AdminContainer';
import useAddCredit from '../../../Hooks/useAddCredit';
import AdminBox from '../../Utility/AdminBox';

function AddCredit() {
    const { TemplateActions, creditTitle, creditAmount, userSettings, i18n } = useAddCredit();

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox>
                    {userSettings.isSuperAdmin && (
                        <div className="flex flex-col gap-4">
                            <div>
                                <label htmlFor="creditTitle" className="block mb-2">
                                    {i18n.translate({ id: 'creditTitle', sourceName: 'AddCredit' })}
                                </label>
                                <Input
                                    inputType="text"
                                    value={creditTitle ?? ''}
                                    onChange={TemplateActions.handleCreditTitleChange}
                                    placeholder={i18n.translate({
                                        id: 'placeholder.creditTitle',
                                        sourceName: 'AddCredit',
                                    })}
                                    id={'creditTitle'}
                                />
                            </div>
                            <div>
                                <label htmlFor="creditAmount" className="block mb-2">
                                    {i18n.translate({ id: 'creditAmount', sourceName: 'AddCredit' })}
                                </label>
                                <Input
                                    inputType="number"
                                    value={creditAmount ?? '0'}
                                    onChange={TemplateActions.handleCreditAmountChange}
                                    inputProps={{ min: 0, step: 0.1 }}
                                    id="creditAmount"
                                />
                            </div>
                        </div>
                    )}
                    <div className="mt-8 text-right">
                        <Button variant="primary" onClick={TemplateActions.handleSave}>
                            {i18n.translate({ id: 'save', sourceName: 'Main' })}
                        </Button>
                    </div>
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default AddCredit;
